import { Container, Row } from "react-bootstrap";
import HeaderLeft from "./components/lleft-side";
import RightSection from "./components/right-side";


function App() {
  return (
    <main>
      <Container className="main-container">
        <Row xs={1} sm={1} md={2}>
          <HeaderLeft/>
          <RightSection/>
        </Row>
      </Container>
    </main>
  );
}

export default App;
